import styled from 'styled-components'
import { SCREEN_MAX_WIDTH } from '../constants'

export const ContentContainer = styled.div`
  width: 100%;
  max-width: ${SCREEN_MAX_WIDTH}px;
  padding: var(--grid-24) 0;
  box-sizing: border-box;

  @media (max-width: ${SCREEN_MAX_WIDTH}px) {
    padding: var(--grid-24);
  }
`

export const ContentContainerMax = styled.div`
  width: 100%;
  max-width: ${SCREEN_MAX_WIDTH}px;
  padding: var(--grid-24) 0;
  box-sizing: border-box;

  @media (max-width: ${SCREEN_MAX_WIDTH}px) {
    padding: var(--grid-24);
  }
`
